import { render } from "./ButtonNextSectionYellow.vue?vue&type=template&id=3c1e68d4"
import script from "./ButtonNextSectionYellow.vue?vue&type=script&lang=js"
export * from "./ButtonNextSectionYellow.vue?vue&type=script&lang=js"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__